// @flow
import * as React from 'react';
import styled from 'styled-components';

const MenuListUl = styled.ul`
  margin: 0;
  padding: 0;
  display: inline-block;
`;

export default (props: { children: React.Node }) => <MenuListUl>{props.children}</MenuListUl>;
